import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  ArrowRight,
  ChevronRight,
  ChevronDown,
  HelpCircle,
  Briefcase,
  DollarSign,
  Users,
  Clock,
  Globe,
  Server,
  Database,
  Cloud,
  Plug,
  TestTube,
  Smartphone,
  Brain,
  Building2,
} from "lucide-react";
import {
  SERVICE_BUNDLES,
  INDIVIDUAL_SERVICES,
  INDUSTRIES,
  INDUSTRY_ICONS,
} from "../data/mock";
import { TEAM_IMAGES } from "@/data/teamImages";
// Integration logos (src/assets/technology_logo)
import aadhaarLogo from "../assets/technology_logo/aadhar.png";
import amazonCognitoLogo from "../assets/technology_logo/amazon.png";
import appPurchaseLogo from "../assets/technology_logo/app_purchase.png";
import applePayLogo from "../assets/technology_logo/applepay.png";
import auth0Logo from "../assets/technology_logo/auth.png";
import awsLogo from "../assets/technology_logo/Amazon-Web-Services-AWS-Symbol.png";
import bluetoothLogo from "../assets/technology_logo/bluetooth.png";
import braintreeLogo from "../assets/technology_logo/braintree.png";
import bugsnagLogo from "../assets/technology_logo/bugsnag.png";
import connexpayLogo from "../assets/technology_logo/conne.png";
import experianLogo from "../assets/technology_logo/experian.png";
import firebaseLogo from "../assets/technology_logo/firebase.png";
import googleMapsLogo from "../assets/technology_logo/google_maps_platform.png";
import googlePayLogo from "../assets/technology_logo/googlepay.png";
import googleWalletLogo from "../assets/technology_logo/google_wallett.png";
import jwPlayerLogo from "../assets/technology_logo/jw_player.png";
import kountLogo from "../assets/technology_logo/kount.png";
import lottieFilesLogo from "../assets/technology_logo/lattie_files.png";
import mixpanelLogo from "../assets/technology_logo/mix_pannel.png";
import nfcLogo from "../assets/technology_logo/nfc.png";
import openWeatherLogo from "../assets/technology_logo/open_whether.png";
import paypalLogo from "../assets/technology_logo/paypal.png";
import plaidLogo from "../assets/technology_logo/plaid.png";
import scanditLogo from "../assets/technology_logo/scandit.png";
import smartlookLogo from "../assets/technology_logo/smart_talk.png";
import squareLogo from "../assets/technology_logo/squre.png";
import stripeLogo from "../assets/technology_logo/stripe.png";
import uxcamLogo from "../assets/technology_logo/uxcam.png";
import walletLogo from "../assets/technology_logo/wallet.png";

// Technology data
const TECHNOLOGIES = {
  mobile: {
    title: "Mobile",
    icon: Smartphone,
    items: [
      {
        name: "React Native",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
      },
      {
        name: "iOS Swift",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/swift/swift-original.svg",
      },
      {
        name: "Android Kotlin",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kotlin/kotlin-original.svg",
      },
      {
        name: "Flutter",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg",
      },
      {
        name: "Java",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
      },
    ],
  },
  frontend: {
    title: "Frontend",
    icon: Globe,
    items: [
      {
        name: "React JS",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
      },
      {
        name: "Vue.js",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original.svg",
      },
      {
        name: "Angular",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg",
      },
      {
        name: "Next.js",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg",
      },
      {
        name: "TypeScript",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg",
      },
      {
        name: "Tailwind",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original.svg",
      },
    ],
  },
  backend: {
    title: "Backend",
    icon: Server,
    items: [
      {
        name: "Python",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg",
      },
      {
        name: "Node.js",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
      },
      {
        name: "PHP",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg",
      },
      {
        name: "Laravel",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/laravel/laravel-original.svg",
      },
      {
        name: "Django",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/django/django-plain.svg",
      },
      {
        name: ".NET",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dotnetcore/dotnetcore-original.svg",
      },
        {
        name: "Java",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
      },
      {
        name: "Ruby on Rails",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/rails/rails-plain.svg",
      },
    ],
  },
  database: {
    title: "Database",
    icon: Database,
    items: [
      {
        name: "PostgreSQL",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg",
      },
      {
        name: "MongoDB",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
      },
      {
        name: "MySQL",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg",
      },
      {
        name: "Redis",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redis/redis-original.svg",
      },
      {
        name: "Firebase",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg",
      },
      {
        name: "Elasticsearch",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/elasticsearch/elasticsearch-original.svg",
      },
    ],
  },
  ai: {
    title: "AI & ML",
    icon: Brain,
    items: [
      {
        name: "TensorFlow",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tensorflow/tensorflow-original.svg",
      },
      {
        name: "PyTorch",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/pytorch/pytorch-original.svg",
      },
      {
        name: "OpenAI",
        logo: TEAM_IMAGES.openai,
      },
      {
        name: "Scikit-learn",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/scikitlearn/scikitlearn-original.svg",
      },
      {
        name: "Hugging Face",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg",
      },
      {
        name: "LangChain",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg",
      },
    ],
  },
  cloud: {
    title: "Cloud & DevOps",
    icon: Cloud,
    items: [
      {
        name: "AWS",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-original-wordmark.svg",
      },
      {
        name: "Google Cloud",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/googlecloud/googlecloud-original.svg",
      },
      {
        name: "Azure",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-original.svg",
      },
      {
        name: "Docker",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
      },
      {
        name: "Kubernetes",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg",
      },
      {
        name: "GitHub Actions",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg",
      },
    ],
  },
  integrations: {
    title: "Integrations",
    icon: Plug,
    items: [
      // Payments
      { name: "Stripe", logo: stripeLogo },
      { name: "PayPal", logo: paypalLogo },
      { name: "Braintree", logo: braintreeLogo },
      { name: "Square", logo: squareLogo },
      { name: "ConnexPay", logo: connexpayLogo },
      { name: "In-App Purchase", logo: appPurchaseLogo },
      { name: "Google Pay", logo: googlePayLogo },
      { name: "Apple Pay", logo: applePayLogo },
      { name: "Google Wallet", logo: googleWalletLogo },
      { name: "Wallet", logo: walletLogo },

      // Identity, risk & data
      { name: "Auth0", logo: auth0Logo },
      { name: "Amazon Cognito", logo: amazonCognitoLogo },
      { name: "Aadhaar", logo: aadhaarLogo },
      { name: "Plaid", logo: plaidLogo },
      { name: "Experian", logo: experianLogo },
      { name: "Kount", logo: kountLogo },

      // Platform & cloud
      { name: "AWS", logo: awsLogo },
      { name: "Firebase", logo: firebaseLogo },
      { name: "Google Maps Platform", logo: googleMapsLogo },
      { name: "OpenWeather", logo: openWeatherLogo },

      // Media & device
      { name: "JW Player", logo: jwPlayerLogo },
      { name: "LottieFiles", logo: lottieFilesLogo },
      { name: "Scandit", logo: scanditLogo },
      { name: "NFC", logo: nfcLogo },
      { name: "Bluetooth Low Energy", logo: bluetoothLogo },

      // Analytics & monitoring
      { name: "Mixpanel", logo: mixpanelLogo },
      { name: "UXCam", logo: uxcamLogo },
      { name: "Bugsnag", logo: bugsnagLogo },
      { name: "Smartlook", logo: smartlookLogo },

      // Protocols
      {
        name: "Socket.io",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/socketio/socketio-original.svg",
      },
      {
        name: "GraphQL",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/graphql/graphql-plain.svg",
      },
      {
        name: "REST APIs",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
      },
    ],
  },
  qa: {
    title: "QA & Testing",
    icon: TestTube,
    items: [
      {
        name: "Selenium",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/selenium/selenium-original.svg",
      },
      {
        name: "Cypress",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cypressio/cypressio-original.svg",
      },
      {
        name: "Jest",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jest/jest-plain.svg",
      },
      {
        name: "Mocha",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mocha/mocha-plain.svg",
      },
      {
        name: "Postman",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postman/postman-original.svg",
      },
      {
        name: "Pytest",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/pytest/pytest-original.svg",
      },
    ],
  },
};

// FAQ Data
const FAQ_DATA = [
  {
    question: "What services does Infotech.Works offer?",
    answer:
      "We offer comprehensive technology services including Mobile App Development, Web Application Development, AI & Machine Learning Solutions, IoT Development, Cloud Solutions, UI/UX Design, Quality Assurance, and DevOps services. Our expertise spans across 20+ industries.",
  },
  {
    question: "How do you ensure project delivery within timeline?",
    answer:
      "We follow Agile methodology with 2-week sprint cycles, daily standups, and regular client demos. Our project managers use proven tools for tracking progress, and we maintain transparent communication through weekly status reports.",
  },
  {
    question: "What engagement models do you offer?",
    answer:
      "We offer three flexible engagement models: Fixed Price for well-defined projects, Fixed Team (Dedicated Team) for long-term partnerships, and Time & Material for projects with evolving requirements. We help you choose the best model based on your needs.",
  },
  {
    question: "How do you handle communication and project updates?",
    answer:
      "We assign a dedicated Project Manager as your single point of contact. Communication happens through your preferred channels (Slack, Teams, Email). You'll receive daily updates during active development and weekly progress reports.",
  },
  {
    question: "What technologies do you specialize in?",
    answer:
      "Our team is proficient in React Native, Swift, Kotlin, Flutter for mobile; React, Angular, Vue.js for frontend; Node.js, Python, PHP, .NET for backend; AWS, Azure, Google Cloud for infrastructure; and TensorFlow, PyTorch for AI/ML.",
  },
  {
    question: "Can you scale the team based on project requirements?",
    answer:
      "Absolutely. Our flexible resource model allows us to scale teams up or down based on project phases. We can adjust team composition within 1-2 weeks while maintaining project continuity.",
  },
  {
    question: "What is your quality assurance process?",
    answer:
      "We follow a comprehensive QA process including unit testing, integration testing, system testing, and UAT. Our QA team works alongside developers from day one, implementing automated testing where applicable.",
  },
  {
    question: "How do you handle data security?",
    answer:
      "Security is paramount. We sign NDAs before project kickoff, implement role-based access controls, use encrypted communication channels, and follow secure coding practices (OWASP guidelines).",
  },
  {
    question: "What happens after the project is delivered?",
    answer:
      "We provide comprehensive post-launch support including a warranty period for bug fixes, knowledge transfer sessions, detailed documentation, and optional maintenance contracts.",
  },
  {
    question: "How do I get started with a new project?",
    answer:
      "Getting started is easy! Contact us through our website or email. We'll schedule a discovery call to understand your requirements, followed by a detailed proposal with scope, timeline, and cost estimates.",
  },
];

// What We Do Section
export const WhatWeDoSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="inline-flex items-center px-4 py-2 bg-blue-50 text-blue-600 rounded-full text-sm font-semibold mb-4">
            Our Services
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            What We Do
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Comprehensive services to bring your vision to life
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          <div className="bg-gray-50 rounded-2xl p-8 border border-gray-100">
            <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center">
              <div className="w-10 h-10 bg-red-50 rounded-lg flex items-center justify-center mr-3">
                <Briefcase className="h-5 w-5 text-[#b32126]" />
              </div>
              Service Bundles
            </h3>
            <div className="space-y-3">
              {SERVICE_BUNDLES.map((service) => (
                <Link
                  key={service.slug}
                  to={`/what-we-do/${service.slug}`}
                  className="flex items-center justify-between p-4 rounded-xl bg-white hover:bg-gray-50 transition-colors group border border-gray-100"
                >
                  <span className="font-medium text-gray-700 group-hover:text-[#b32126]">
                    {service.title}
                  </span>
                  <ChevronRight className="h-5 w-5 text-gray-400 group-hover:text-[#b32126]" />
                </Link>
              ))}
            </div>
          </div>

          <div className="bg-gray-50 rounded-2xl p-8 border border-gray-100">
            <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center">
              <div className="w-10 h-10 bg-red-50 rounded-lg flex items-center justify-center mr-3">
                <Plug className="h-5 w-5 text-[#b32126]" />
              </div>
              Individual Services
            </h3>
            <div className="grid grid-cols-2 gap-2">
              {INDIVIDUAL_SERVICES.slice(0, 8).map((service) => (
                <Link
                  key={service.slug}
                  to={`/what-we-do/${service.slug}`}
                  className="p-3 rounded-lg bg-white hover:bg-gray-50 transition-colors group border border-gray-100"
                >
                  <span className="text-sm font-medium text-gray-600 group-hover:text-[#b32126]">
                    {service.title}
                  </span>
                </Link>
              ))}
            </div>
            <Link
              to="/what-we-do"
              className="inline-flex items-center text-[#b32126] font-medium mt-4 hover:text-[#8f1a1f]"
            >
              View All Services <ChevronRight className="h-4 w-4 ml-1" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

// Engagement Models Section
export const EngagementModelsSection = ({ bgColor = "bg-gray-50" }) => {
  return (
    <section className={`py-20 ${bgColor}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="inline-flex items-center px-4 py-2 bg-indigo-50 text-indigo-600 rounded-full text-sm font-semibold mb-4">
            Flexible Partnership
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Engagement Models
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Choose the partnership model that best fits your project needs
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <Link
            to="/what-we-do/engagement-model#fixed-price"
            className="group relative bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all border border-gray-100 hover:border-emerald-200 overflow-hidden"
          >
            <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-emerald-500/10 to-teal-500/10 rounded-full -mr-16 -mt-16 group-hover:scale-150 transition-transform duration-500" />
            <div className="relative">
              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-emerald-500 to-teal-600 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <DollarSign className="h-8 w-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-emerald-600 transition-colors">
                Fixed Price
              </h3>
              <p className="text-gray-600 mb-4">
                Predictable budgets with well-defined scope. Ideal for projects
                with clear requirements.
              </p>
              <ul className="space-y-2 mb-6">
                <li className="flex items-center text-sm text-gray-500">
                  <ChevronRight className="h-4 w-4 text-emerald-500 mr-2" />
                  Budget certainty upfront
                </li>
                <li className="flex items-center text-sm text-gray-500">
                  <ChevronRight className="h-4 w-4 text-emerald-500 mr-2" />
                  Milestone-based delivery
                </li>
                <li className="flex items-center text-sm text-gray-500">
                  <ChevronRight className="h-4 w-4 text-emerald-500 mr-2" />
                  Clear deliverables
                </li>
              </ul>
              <span className="inline-flex items-center text-emerald-600 font-medium group-hover:translate-x-2 transition-transform">
                Learn More <ArrowRight className="ml-2 h-4 w-4" />
              </span>
            </div>
          </Link>

          <Link
            to="/what-we-do/engagement-model#fixed-team"
            className="group relative bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all border border-gray-100 hover:border-blue-200 overflow-hidden"
          >
            <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-blue-500/10 to-indigo-500/10 rounded-full -mr-16 -mt-16 group-hover:scale-150 transition-transform duration-500" />
            <div className="relative">
              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <Users className="h-8 w-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors">
                Fixed Team
              </h3>
              <p className="text-gray-600 mb-4">
                Dedicated team working exclusively on your project. Perfect for
                long-term partnerships.
              </p>
              <ul className="space-y-2 mb-6">
                <li className="flex items-center text-sm text-gray-500">
                  <ChevronRight className="h-4 w-4 text-blue-500 mr-2" />
                  Dedicated resources
                </li>
                <li className="flex items-center text-sm text-gray-500">
                  <ChevronRight className="h-4 w-4 text-blue-500 mr-2" />
                  Deep domain expertise
                </li>
                <li className="flex items-center text-sm text-gray-500">
                  <ChevronRight className="h-4 w-4 text-blue-500 mr-2" />
                  Seamless integration
                </li>
              </ul>
              <span className="inline-flex items-center text-blue-600 font-medium group-hover:translate-x-2 transition-transform">
                Learn More <ArrowRight className="ml-2 h-4 w-4" />
              </span>
            </div>
          </Link>

          <Link
            to="/what-we-do/engagement-model#time-and-material"
            className="group relative bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all border border-gray-100 hover:border-purple-200 overflow-hidden"
          >
            <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-purple-500/10 to-violet-500/10 rounded-full -mr-16 -mt-16 group-hover:scale-150 transition-transform duration-500" />
            <div className="relative">
              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-purple-500 to-violet-600 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <Clock className="h-8 w-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-purple-600 transition-colors">
                Time & Material
              </h3>
              <p className="text-gray-600 mb-4">
                Maximum flexibility for evolving requirements. Pay for actual
                time and resources used.
              </p>
              <ul className="space-y-2 mb-6">
                <li className="flex items-center text-sm text-gray-500">
                  <ChevronRight className="h-4 w-4 text-purple-500 mr-2" />
                  Complete flexibility
                </li>
                <li className="flex items-center text-sm text-gray-500">
                  <ChevronRight className="h-4 w-4 text-purple-500 mr-2" />
                  Transparent billing
                </li>
                <li className="flex items-center text-sm text-gray-500">
                  <ChevronRight className="h-4 w-4 text-purple-500 mr-2" />
                  Scale as needed
                </li>
              </ul>
              <span className="inline-flex items-center text-purple-600 font-medium group-hover:translate-x-2 transition-transform">
                Learn More <ArrowRight className="ml-2 h-4 w-4" />
              </span>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
};

// Technologies Section
export const TechnologiesSection = () => {
  const [activeTab, setActiveTab] = useState("mobile");

  return (
    <section className="py-20 bg-gradient-to-b from-gray-900 to-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          {/* <span className="inline-flex items-center px-4 py-2 bg-white/10 text-red-300 rounded-full text-sm font-semibold mb-4">
            Tech Stack
          </span> */}
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Technologies We Use
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Industry-leading tools and frameworks to build robust solutions
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {Object.entries(TECHNOLOGIES)
            .sort(([, a], [, b]) => a.title.localeCompare(b.title))
            .map(([key, category]) => {
            const IconComponent = category.icon;
            return (
              <button
                key={key}
                onClick={() => setActiveTab(key)}
                className={`flex items-center px-5 py-3 rounded-xl font-medium transition-all ${
                  activeTab === key
                    ? "bg-[#b32126] text-white shadow-lg"
                    : "bg-white/10 text-gray-300 hover:bg-white/20"
                }`}
              >
                <IconComponent className="h-5 w-5 mr-2" />
                {category.title}
              </button>
            );
          })}
        </div>

        <div className="bg-white/5 backdrop-blur-sm rounded-3xl p-8 border border-white/10">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6">
            {TECHNOLOGIES[activeTab].items.map((tech, index) => (
              <div
                // key={index}
                key={tech.name}
                className="group flex flex-col items-center p-4 bg-white/5 rounded-xl hover:bg-white/10 transition-all"
              >
                <div className="w-24 h-20 flex items-center justify-center mb-3 bg-white rounded-xl p-3 group-hover:scale-110 transition-transform shadow-lg">
                  <img
                    src={tech.logo}
                    alt={tech.name}
                    className="max-w-full max-h-full object-contain"
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                </div>
                <span className="text-white text-sm font-medium text-center">
                  {tech.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

// FAQ Section
export const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="inline-flex items-center px-4 py-2 bg-amber-50 text-amber-600 rounded-full text-sm font-semibold mb-4">
            <HelpCircle className="h-4 w-4 mr-2" />
            Got Questions?
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Find answers to common questions about our services and process
          </p>
        </div>

        <div className="space-y-4">
          {FAQ_DATA.map((faq, index) => (
            <div
              key={index}
              className={`border rounded-2xl overflow-hidden transition-all duration-300 ${
                openIndex === index
                  ? "shadow-lg border-[#b32126]/30 bg-white"
                  : "border-gray-200 bg-gray-50 hover:border-gray-300"
              }`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left"
              >
                <span
                  className={`font-semibold pr-4 ${
                    openIndex === index ? "text-[#b32126]" : "text-gray-900"
                  }`}
                >
                  {faq.question}
                </span>
                <div
                  className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300 ${
                    openIndex === index
                      ? "bg-[#b32126]/10 rotate-180"
                      : "bg-gray-200"
                  }`}
                >
                  <ChevronDown
                    className={`h-5 w-5 ${
                      openIndex === index ? "text-[#b32126]" : "text-gray-500"
                    }`}
                  />
                </div>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? "max-h-96" : "max-h-0"
                }`}
              >
                <div className="px-6 pb-5 text-gray-600 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Industries Section
export const IndustriesSection = ({
  title = "Industries We Serve",
  subtitle = "Delivering solutions across diverse industry verticals",
}) => {
  const showcaseIndustries = INDUSTRIES.slice(0, 12);

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-2">{title}</h2>
            <p className="text-gray-600">{subtitle}</p>
          </div>
          <Link
            to="/industries"
            className="hidden md:flex items-center font-medium hover:text-[#8f1a1f] transition-colors"
            style={{ color: "#b32126" }}
          >
            View All <ChevronRight className="h-4 w-4 ml-1" />
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {showcaseIndustries.map((industry) => {
            const IconComponent = INDUSTRY_ICONS[industry.slug] || Building2;
            return (
              <Link
                key={industry.slug}
                to={`/industries/${industry.slug}`}
                className="group bg-white p-4 rounded-xl border border-gray-200 hover:border-[#b32126]/30 hover:shadow-lg transition-all text-center"
              >
                <div
                  className="w-12 h-12 mx-auto rounded-xl flex items-center justify-center mb-3 group-hover:scale-110 transition-transform"
                  style={{
                    background:
                      "linear-gradient(135deg, #d64449 0%, #b32126 50%, #8f1a1f 100%)",
                  }}
                >
                  <IconComponent className="h-6 w-6 text-white" />
                </div>
                <span className="text-sm font-medium text-gray-700 group-hover:text-[#b32126]">
                  {industry.title}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

// Combined Common Sections Component
const CommonSections = ({
  showWhatWeDo = true,
  showIndustries = true,
  engagementBgColor = "bg-gray-50",
}) => {
  return (
    <>
      {showWhatWeDo && <WhatWeDoSection />}
      {showIndustries && <IndustriesSection />}
      <EngagementModelsSection bgColor={engagementBgColor} />
      <TechnologiesSection />
      <FAQSection />
    </>
  );
};

export default CommonSections;
